import React, { useState, useRef, useEffect } from 'react';

const Choosing = () => {
  const ChoosingData = [
    {
      heading: "Affordability",
      description: "We offer competitive pricing plans tailored to meet the budgetary constraints of businesses, startups, and individuals.",
    },
    {
      heading: "Customization",
      description: "Our team works closely with clients to understand their unique needs and preferences, delivering customized websites that align with their brand identity and objectives.",
    },
    {
      heading: "Quality Assurance",
      description: "Despite offering low-cost solutions, we never compromise on quality. Our websites are built using the latest technologies and best practices to ensure performance, security, and reliability.",
    },
    {
      heading: "Responsive Design",
      description: "All our websites are designed with responsiveness in mind, ensuring a seamless user experience across devices and screen sizes.",
    }
  ];

  const [openIndex, setOpenIndex] = useState(null); // State to track the open accordion index

  const handleToggleAccordion = (index) => {
    setOpenIndex(prevIndex => (prevIndex === index ? null : index)); // Toggle the selected accordion
  };

  return (
    <div className="col-lg-6 " style={{ marginBottom: '30px' }}>
      <div className="accordions-new is-first-expanded">
        {ChoosingData.map((item, index) => (
          <AccordionItem
            key={index}
            title={item.heading}
            content={item.description}
            isOpen={openIndex === index}  // Pass the open state as a prop
            onToggle={() => handleToggleAccordion(index)}  // Pass the toggle function as a prop
          />
        ))}
      </div>
    </div>
  );
};

const AccordionItem = ({ title, content, isOpen, onToggle }) => {
  const contentRef = useRef(null);

  useEffect(() => {
    if (contentRef.current) {
      if (isOpen) {
        contentRef.current.style.maxHeight = contentRef.current.scrollHeight + 'px';
      } else {
        contentRef.current.style.maxHeight = '0px';
      }
    }
  }, [isOpen]);

  return (
    <article className="accordion">
      <div className="accordion-head" onClick={onToggle}>
        <span className='web-acc-heading'>{title}</span>
        <span className={`icon ${isOpen ? 'open' : ''}`}>
          <i className={`fa ${isOpen ? 'fa-chevron-down' : 'fa-chevron-right'}`}></i>
        </span>
      </div>
      <div
        ref={contentRef}
        className={`accordion-body ${isOpen ? 'open' : ''}`}
        style={{ maxHeight: isOpen ? `${contentRef.current?.scrollHeight}px` : '0px' }}
      >
        <div className="content">
          <p>{content}</p>
        </div>
      </div>
    </article>
  );
};

export default Choosing;
